import React, { useState } from 'react';
import HeatmapView from './HeatmapView';
import Controls from './Controls';
import { HeatmapFilters } from './types/HeatmapTypes';

const HeatmapPanel: React.FC = () => {
  const [filters, setFilters] = useState<HeatmapFilters>({
    hours: 24,
    resolution: 3,
    limitPerIccid: 50,
    minCount: 3,
  });

  return (
    <div className="flex flex-col h-[calc(100vh-7rem)] bg-gray-50">
      <Controls filters={filters} onFiltersChange={setFilters} />

      <div className="flex-1 relative">
        <HeatmapView filters={filters} />
      </div>
    </div>
  );
}

export default HeatmapPanel;

